<template>
    <div class="store-two-step">
        <a-form :form="form" @submit="handleSubmit" >
            <a-form-item label="主管信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select show-search :filter-option="filterOption" option-filter-prop="children" @change="change" :options="userList" placeholder="请输入" :disabled="stepTwoDisable" v-decorator="['principalStaffId',{rules: [{required: true, message: '请输入主管信息',}]}]" ></a-select>
            </a-form-item>
            <a-form-item label="主管手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input :disabled="true" v-model="phone" />
            </a-form-item>
            <a-form-item label="登录账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input :disabled="true" v-model="account" />
            </a-form-item>
            <a-form-item label="登录密码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input type="password" :disabled="true" v-model="password" />
            </a-form-item>
            <a-form-item class="text-center" v-if="showStepTwoBtn">
                <a-button @click="backStep">上一步</a-button>
                <a-button type="primary" html-type="submit" >下一步</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
export default {

    /**
     * 场地主管信息组件
     * @prop {Boolean} stepTwoDisable 禁用所有表单项，第四步和查看详情时为true
     * @prop {Boolean} showStepTwoBtn 第四步时控制操作按钮是否展示
     * @prop {Object} allData 编辑和查看详情时获取所有接口数据
     *
     */
    name: "newStepTwo",
    zh: "场地主管信息组件",
    data() {
        return {
            labelCol: {span: 8},
            wrapperCol: {span: 8},
            flag: false,
            userList: [],
            phone: null,
            account: null,
            password: null
        }
    },
    props: {
        stepTwoDisable: {
            type: Boolean,
            required: true
        },
        showStepTwoBtn: {
            type: Boolean,
            required: true
        },
        allData: { type: Object }
    },
    methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        change(val) {
            let { phone, account } = this.userList.find(i => i.id === val);
            this.phone = phone;
            this.account = account;
            this.password = '123456';
        },
        /**
         * @获取总平台用户列表
         */
        getUserList() {
            this.$api.jurisdiction.userList({
                body: {
                    isEnable: !this.stepTwoDisable || undefined,
                    pageNum: 1,
                    pageSize: 99999
                }
            }).then(res => {
                res.list.forEach((i) => {
                    i.value = i.id;
                    i.label = i.name;
                });
                this.userList = res.list;
                if (this.allData.principalStaffId) {
                    let currentUser = this.userList.find(i => i.id === this.allData.principalStaffId);
                    if (!currentUser) {
                        return false;
                    }
                    let { phone, account } = this.userList.find(i => i.id === this.allData.principalStaffId);
                    this.phone = phone;
                    this.account = account;
                    this.password = '123456';
                }
            });
        },
        // 当点击提交时将第一步的全部内容传给父组件 同时隐藏第二步 显示第三步
        handleSubmit (e) {
            e.preventDefault();
            if(this.flag) {
                this.$message.error('登录账号重复，请重新输入')
                return false
            }
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.$emit('stepTwoData',{
                        current: 2,
                        twoDisable: true,
                        showTwoBtn: false,
                        principalStaffId: values.principalStaffId
                    })
                }
            });
        },
        backStep() {
            this.$emit('stepTwoData',{current: 0});
        }
    },
    beforeCreate () {
        this.form = this.$form.createForm(this);
    },
    mounted() {
        setTimeout(() => {
            this.getUserList();
        }, 500);
    },
    watch: {
        'allData'(newValue) {
            let valuesForm = {
                principalStaffId: newValue.principalStaffId
            }
            setTimeout(() => {
                this.form.setFieldsValue(valuesForm);
            },300)
        },
    }
}
</script>

<style lang="scss">
</style>
